import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import { flattenToAppURL } from '@plone/volto/helpers';
import { searchSchedaPersona } from 'uniba-volto-persone/actions';
import debounce from 'lodash/debounce';
import isEqual from 'lodash/isEqual';
import { Spinner } from 'design-react-kit';
import {
    SearchRubricaBackgroundUser,
    SearchRubricaBackground,
    PersonaTemplate,
} from 'uniba-volto-persone/components';
import { Icon } from 'design-comuni-plone-theme/components/ItaliaTheme';
import { getApiURL } from 'design-comuni-plone-theme/components';
import Filter from './Filter';
import config from '@plone/volto/registry';
import { Dropdown, DropdownItem, DropdownMenu } from 'semantic-ui-react';
import { NavLink } from 'react-router-dom';
import ReactDOM from 'react-dom';

const strutturaParam = 'indexChainBelongs';
const searchParam = 'SearchableText';
const minCharsForDropdown = 3;
class Body extends Component {
    constructor(props) {
        super(props);
        this.state = {
            inputText: '',
            searchedInputText: '',
            strutturaCercataTitle: '',
            currentPage: 1,
            fineRisultati: false,
            clearResults: false,
            pages: [],
            isLoadingMore: false,
            searchValue: null,
            searchResults: [],
            searchQuerystringResults: {},
            strutturaValue: null,
            dropdownHeight: 0,
            prevQuery: {},
            isSearchbarFocused: false,
            isDropdownHovered: false,
            searchbarHighlightedIndex: -1,
            hasSearched: false,
        };

        this.inputRef = createRef();
        this.dropdownRef = createRef();
        this.itemRefs = [];
        this.b_size = 30;

        this.handleScroll = debounce(this.handleScroll.bind(this), 200);
    }

    parametersFromGet(location) {
        const queryParams = new URLSearchParams(location.search);
        const newStrutturaValue = queryParams.get(strutturaParam) || queryParams.get(strutturaParam + ':string');
        const newSearchValue = queryParams.get(searchParam);
        return {
            struttura: newStrutturaValue,
            search: newSearchValue,
        };
    }

    setGetSearch(search) {
        const { history, location } = this.props;
        const queryParams = new URLSearchParams(location.search);
        queryParams.set(searchParam, search);
        history.replace(`${location.pathname}?${queryParams.toString()}`);
    }

    handleScroll() {
        const {
            searchedInputText,
            searchValue,
            strutturaValue,
            currentPage,
            searchQuerystringResults,
        } = this.state;

        const bottom =
            window.innerHeight + document.documentElement.scrollTop >=
            document.documentElement.scrollHeight - window.innerHeight / 2;

        if (bottom && (searchedInputText !== '' || searchValue || strutturaValue)) {
            if (searchQuerystringResults?.total > currentPage * this.b_size) {
                this.setState((state) => ({ currentPage: state.currentPage + 1 }));
            } else {
                this.setState({ fineRisultati: true });
            }
        }
    }

    generateQuery(overrideText, overrideStrutt, setInputOnGet = true) {
        const { data } = this.props;
        const { inputText, searchValue, strutturaValue } = this.state;

        let query_gen = [
            {
                i: 'portal_type',
                o: 'plone.app.querystring.operation.selection.any',
                v: ['SchedaPersona'],
            },
            {
                i: 'path',
                o: 'plone.app.querystring.operation.string.absolutePath',
                v: data?.path?.getPath ?? '/rubrica',
            },
        ];
        let finalStrutturaValue = overrideStrutt || strutturaValue;
        if (finalStrutturaValue) {
            query_gen.push({
                i: strutturaParam,
                o: 'plone.app.querystring.operation.string.is',
                v: finalStrutturaValue,
            });
        }
        let finalSearchValue = overrideText || inputText || searchValue;
        if (inputText && setInputOnGet) {
            this.setGetSearch(inputText);
        }
        if (finalSearchValue) {
            query_gen.push({
                i: 'SearchableText',
                o: 'plone.app.querystring.operation.string.is',
                v: `${finalSearchValue}*`,
            });
        }
        return query_gen;
    }

    doRequest(
        query,
        b_start = 0,
        b_size = this.b_size,
        id_query = '_rubrica_search',
        sort_on,
        sort_order,
    ) {
        const { dispatch, data, subsite } = this.props;

        const q = query || this.generateQuery();
        if (!q) return;
        this.setState({
            prevQuery: query,
        });
        const finalSortOn = sort_on ?? data.sort_on ?? 'sortable_scheda';
        const finalSortOrder =
            sort_order ?? (data.sort_order ? 'descending' : 'ascending');
        this.setState({ fineRisultati: false });
        dispatch(
            searchSchedaPersona(
                subsite ? flattenToAppURL(subsite['@id']) : '',
                {
                    fullobjects: 0,
                    query: q,
                    b_start,
                    b_size,
                    sort_on: finalSortOn,
                    sort_order: finalSortOrder,
                    metadata_fields: '_all',
                },
                id_query,
            ),
        );
    }

    async getStruttura(uid) {
        try {
            const response = await fetch(
                `${config.settings.apiPath}/++api++/resolveuid/${uid}`,
                {
                    method: 'GET',
                    redirect: 'follow',
                },
            );

            if (!response.ok) {
                throw new Error('Errore nel recupero del redirect a struttura');
            }

            let strutturaUrl = response.url;
            let strutturaApiUrl = getApiURL(strutturaUrl);

            const response2 = await fetch(strutturaApiUrl, {
                method: 'GET',
            });

            if (!response2.ok) {
                throw new Error('Errore nel recupero della struttura');
            }

            const responseData = await response2.json();
            this.setState({ strutturaCercataTitle: responseData.title });
        } catch (error) {
            console.error('Errore nel recupero della struttura:', error);
        }
    }

    removeStruttValueGET() {
        const { strutturaValue } = this.state;
        const { history, location } = this.props;
        if (!strutturaValue) return;
        var queryParams = new URLSearchParams(location.search);
        queryParams.delete(strutturaParam);
        history.replace(`${location.pathname}?${queryParams.toString()}`);
        this.setState({ fineRisultati: false });
    }

    startSearch(e) {
        e.preventDefault();
        const { inputText = '' } = this.state;
        if (!inputText) return;

        const { dd_items = [], dd_querystringResults } = this.props;

        this.setGetSearch(inputText);
        if (dd_items.length === 0) {
            const query = this.generateQuery(inputText, undefined, true);
            this.doRequest(query);
        } else {
            this.setState({
                searchResults: dd_items,
                searchQuerystringResults: dd_querystringResults,
            });
        }

        this.setState({
            currentPage: 1,
            pages: [],
            searchedInputText: inputText,
            searchValue: inputText,
            clearResults: false,
            dropdownHeight: 0,
            hasSearched: true,
        });
    }

    highlightIndex = (index) => {
        this.setState({ searchbarHighlightedIndex: index }, () => {
            const el = this.itemRefs[index];
            if (el && el.scrollIntoView) {
                el.scrollIntoView({ block: 'nearest', inline: 'nearest' });
            }
        });
    };

    selectItem = (index, item) => {
        // Naviga e chiudi in modo pulito
        this.props.history.push(`/rubrica/${item.id}`);
        this.setState({
            isSearchbarFocused: false,
            searchedInputText: this.state.inputText,
            searchbarHighlightedIndex: -1,
        });
    };

    dropdownHandleKeyDown(e) {
        const { searchbarHighlightedIndex } = this.state;
        const items = this.props.dd_items || [];

        if (e.key === 'ArrowDown') {
            e.preventDefault();
            if (items.length > 0) {
                const next = (searchbarHighlightedIndex + 1) % items.length;
                this.highlightIndex(next);
            }
        } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            if (items.length > 0) {
                const prev =
                    (searchbarHighlightedIndex - 1 + items.length) % items.length;
                this.highlightIndex(prev);
            }
        } else if (e.key === 'Enter') {
            e.preventDefault();
            if (searchbarHighlightedIndex >= 0 && items[searchbarHighlightedIndex]) {
                // selezione l'elemento evidenziato
                const sel = items[searchbarHighlightedIndex];
                this.selectItem(searchbarHighlightedIndex, sel);
            } else {
                // altrimenti avvia la ricerca classica
                this.startSearch(e);
            }
        }
    }

    componentDidMount() {
        const { location, search_items, search_querystringResults } = this.props;
        const { struttura, search } = this.parametersFromGet(location);

        if (this.inputRef.current) {
            this.inputRef.current.focus();
        }

        if (struttura || search) {
            this.setState(
                {
                    searchValue: search,
                    strutturaValue: struttura,
                    inputText: search,
                    clearResults: false,
                },
                () => {
                    const query = this.generateQuery(search, struttura);
                    if (!isEqual(this.state.prevQuery, query)) {
                        this.doRequest(query);
                    }
                },
            );
            this.props.onSearchInputChange?.(struttura || search || '');
        } else if (this.state.inputText) {
            this.setGetSearch(this.state.inputText);
        } else {
            this.setState({ clearResults: true });
        }

        window.addEventListener('scroll', this.handleScroll);
    }

    componentDidUpdate(prevProps, prevState) {
        const {
            location,
            ssp_subrequests,
            search_loading,
            search_items,
            search_querystringResults,
            dd_loading,
            dd_items,
            dd_querystringResults
        } = this.props;

        const {
            strutturaValue,
            searchValue,
            searchedInputText,
            currentPage,
            pages,
            searchQuerystringResults,
            searchResults,
            hasSearched,
        } = this.state;

        const dynamicKey = '_rubrica_search_' + currentPage;
        const additional_items = ssp_subrequests?.[dynamicKey]?.items;

        const additional_loading = ssp_subrequests?.[dynamicKey]?.loading || false;

        const prev_additional_items =
            prevProps.ssp_subrequests?.[dynamicKey]?.items;

        const prev_additional_loading =
            prevProps.ssp_subrequests?.[dynamicKey]?.loading || false;

        // Al cambio dell inputText, se diventa con più di minCharsForDropdown
        // caratteri, effettuo una ricerca e scrivo i risultati del dropdown
        if (
            prevState.inputText !== this.state.inputText &&
            this.state.inputText?.length >= minCharsForDropdown
        ) {
            const query = this.generateQuery(this.state.inputText, undefined, false);
            if (!isEqual(this.state.prevQuery, query)) {
                this.doRequest(query, 0, this.b_size, '_rubrica_search_dd');
                this.setState({ pages: [], hasSearched: false });
            }
            this.setState({ clearResults: false });
        }

        // Se la richiesta dd non sta più caricando e i risultati sono cambiati e non sono vuoti e ha cercato
        if (
            prevProps.dd_items !== dd_items &&
            !dd_loading &&
            dd_querystringResults?.loaded &&
            hasSearched
        ) {
            this.setState({
                searchResults: dd_items,
                searchQuerystringResults: dd_querystringResults,
            });
        }

        // Se la richiesta non sta più caricando e i risultati sono cambiati e non sono vuoti
        if (
            prevProps.search_items !== search_items &&
            !search_loading &&
            search_querystringResults?.loaded
        ) {
            this.setState({
                searchResults: search_items,
                searchQuerystringResults: search_querystringResults,
            });
        }

        // Al cambio dell'URL, cambio inputText e searchValue
        // ed eseguo la richiesta
        if (
            location.search !== prevProps.location.search &&
            location.pathname === prevProps.location.pathname
        ) {
            const { struttura = null, search = null } =
                this.parametersFromGet(location);

            const OLDstrutturaValue = prevState.strutturaValue || null;
            const OLDsearchValue = prevState.searchValue || null;

            const strutturaChanged = OLDstrutturaValue !== struttura;
            const searchChanged = OLDsearchValue !== search;

            if (strutturaChanged || searchChanged) {
                this.setState(
                    {
                        searchValue: search,
                        strutturaValue: struttura,
                        clearResults: false,
                    },
                    () => {
                        const { inputText } = this.state;
                        if (struttura || search) {
                            const query = this.generateQuery(search, struttura);
                            if (!isEqual(this.state.prevQuery, query)) {
                                this.doRequest(query);
                            }
                        } else if (inputText) {
                            this.setGetSearch(inputText);
                        } else {
                            this.setState({ clearResults: true });
                        }
                    },
                );

                this.props.onSearchInputChange?.(struttura || search || '');
            }
        }

        // Al cambio degli items, con strutturaValue presente,
        // prendo il nome della struttura
        if (strutturaValue && prevState.searchResults !== searchResults) {
            this.getStruttura(strutturaValue);
        }

        // Al cambio della currentPage (e non è la prima),
        // eseguo una query aggiuntiva
        if (currentPage !== prevState.currentPage && currentPage !== 1) {
            const bstart = (currentPage - 1) * this.b_size;
            this.doRequest(
                undefined,
                bstart,
                this.b_size,
                '_rubrica_search_' + currentPage,
            );
        }

        // Al cambio dei risultati aggiuntivi
        if (
            additional_items !== undefined &&
            additional_items !== prev_additional_items
        ) {
            // Se non sta caricando e i risultati aggiuntivi sono presenti
            if (!additional_loading && additional_items.length > 0) {
                this.setState({
                    isLoadingMore: false,
                    pages: [...pages, additional_items],
                    fineRisultati: additional_items.length < this.b_size,
                });
            }

            // Se non sta caricando e i risultati aggiuntivi NON sono presenti
            if (
                !additional_loading &&
                Array.isArray(additional_items) &&
                additional_items?.length === 0 &&
                searchedInputText !== ''
            ) {
                this.setState({
                    isLoadingMore: false,
                    fineRisultati: true,
                });
            }
        }

        // Quando carico risultati aggiuntivi, vado in stato "loading"
        if (additional_loading && !prev_additional_loading) {
            this.setState({
                isLoadingMore: true,
                fineRisultati: false,
            });
        }

        // Effettuata la ricerca, se i risultati sono minori
        // del massimo numero di risultati per quella pagina,
        // imposto la scritta "Fine dei risultati"
        if (
            (searchedInputText !== '' || searchValue || strutturaValue) &&
            searchQuerystringResults &&
            !searchQuerystringResults.loading &&
            searchQuerystringResults.loaded &&
            searchQuerystringResults?.total < currentPage * this.b_size &&
            !this.state.fineRisultati
        ) {
            this.setState({ fineRisultati: true });
        }

        // Calcolo l'altezza del dropdown se è visibile
        if (
            this.state.inputText?.length >= minCharsForDropdown &&
            this.dropdownRef.current
        ) {
            requestAnimationFrame(() => {
                const el = this.dropdownRef?.current?.ref?.current?.children[0];
                if (el) {
                    const height = el.offsetHeight;
                    if (height !== this.state.dropdownHeight) {
                        this.setState({ dropdownHeight: height });
                    }
                }
            });
        }
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }

    render() {
        const { intl, data, search_loading, dd_items, dd_loading } = this.props;

        const {
            inputText = '',
            fineRisultati,
            pages,
            isLoadingMore,
            searchedInputText,
            strutturaValue,
            searchValue,
            clearResults,
            strutturaCercataTitle,
            dropdownHeight,
            searchResults,
            searchQuerystringResults,
        } = this.state;

        const r_dd_items = clearResults ? [] : dd_items;

        const r_items = searchResults;
        const totalResults = searchQuerystringResults?.total ?? 0;

        const intl_doSearch = intl.formatMessage({ id: 'doSearch' });

        return (
            <div className="public-ui searchRubrica">
                {data?.image ? (
                    <SearchRubricaBackgroundUser image={data.image} />
                ) : (
                    <SearchRubricaBackground />
                )}
                <div className="ui container">
                    {/* Input e risultati */}
                    <div
                        className="searchContainer
                            d-flex w-100 flex-column mt-5"
                    >
                        <h3 className="search-rubrica-title text-primary">
                            {intl.formatMessage({ id: 'rubrica_doSearchHeader' })}
                        </h3>

                        <div className="searchbar shadow-sm d-flex w-100">
                            <button
                                type="button"
                                className="rounded-start"
                                onClick={(event) => {
                                    this.startSearch(event);
                                }}
                                aria-label={intl_doSearch}
                                title={intl_doSearch}
                            >
                                <Icon
                                    icon="it-search"
                                    padding={false}
                                    size="md"
                                    aria-hidden="true"
                                />
                            </button>
                            <label htmlFor="searchInput" className="visually-hidden">
                                {intl.formatMessage({ id: 'searchInRubrica' })}
                            </label>
                            <input
                                id="searchInput"
                                className="inputSearch rounded-end"
                                ref={this.inputRef}
                                type="search"
                                value={inputText}
                                autoComplete="off"
                                onChange={(e) => {
                                    this.setState({
                                        inputText: e.target.value,
                                    });
                                    this.props.onSearchInputChange?.(e.target.value);
                                }}
                                onKeyDown={(e) => this.dropdownHandleKeyDown(e)}
                                onFocus={() => this.setState({ isSearchbarFocused: true })}
                                onBlur={(e) => {
                                    const next = e.relatedTarget;
                                    const dropdownNode =
                                        this.dropdownRef?.current?.ref?.current ||
                                        this.dropdownRef?.current;

                                    const isNextInsideDropdown =
                                        next instanceof Node && dropdownNode instanceof Node
                                            ? dropdownNode.contains(next)
                                            : false;

                                    if (!isNextInsideDropdown) {
                                        this.setState({
                                            isSearchbarFocused: false,
                                            searchbarHighlightedIndex: -1,
                                        });
                                    }
                                }}
                                placeholder={intl.formatMessage({
                                    id: 'rubrica_doSearchHelper',
                                })}
                                aria-label={intl.formatMessage({ id: 'rubrica_doSearchAria' })}
                                title={intl.formatMessage({ id: 'doSearchTitle' })}
                            />
                        </div>
                        <Dropdown
                            open={
                                (this.state.isSearchbarFocused ||
                                    this.state.isDropdownHovered) &&
                                inputText?.length >= minCharsForDropdown &&
                                this.state.searchedInputText !== this.state.inputText &&
                                this.state.inputText !== this.state.searchValue
                            }
                            upward={false}
                            trigger={<></>}
                            className="dropdown-risultati mt-0"
                            icon={null}
                            ref={this.dropdownRef}
                            id="searchInput-dropdownResults"
                            tabIndex={-1}
                        >
                            <DropdownMenu
                                className="menu"
                                onMouseEnter={() => this.setState({ isDropdownHovered: true })}
                                onMouseLeave={() => this.setState({ isDropdownHovered: false })}
                                onMouseDown={(e) => {
                                    e.preventDefault();
                                }}
                            >
                                {dd_loading ? (
                                    <DropdownItem
                                        disabled
                                        className="d-flex justify-content-center align-items-center"
                                    >
                                        <Spinner active size="sm" />
                                    </DropdownItem>
                                ) : r_dd_items.length > 0 ? (
                                    r_dd_items.map((item, index) => (
                                        <DropdownItem
                                            key={item.id}
                                            className={
                                                index === this.state.searchbarHighlightedIndex
                                                    ? 'is-active'
                                                    : ''
                                            }
                                            ref={(el) => {
                                                if (el) {
                                                    this.itemRefs[index] = ReactDOM.findDOMNode(el);
                                                }
                                            }}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    const link = e.currentTarget.querySelector('a');
                                                    if (link) link.click();
                                                }
                                            }}
                                            onClick={(e) => {
                                                e.preventDefault();
                                                this.selectItem(index, item);
                                            }}
                                        >
                                            <NavLink to={`/rubrica/${item.id}`}>
                                                {item.nome} {item.cognome}
                                            </NavLink>
                                        </DropdownItem>
                                    ))
                                ) : (
                                    <DropdownItem disabled>
                                        {intl.formatMessage({ id: 'noResult' })}
                                    </DropdownItem>
                                )}
                            </DropdownMenu>
                        </Dropdown>
                        <div
                            style={{
                                height:
                                    inputText?.length >= minCharsForDropdown
                                        ? `${dropdownHeight}px`
                                        : '0px',
                                transition: 'height 300ms ease',
                                overflow: 'hidden',
                            }}
                        />
                    </div>
                    {(searchedInputText?.trim() ||
                        strutturaValue?.trim() ||
                        searchValue?.trim()) && (
                            <>
                                {/* Testo Helper "Risultati per: " */}
                                <h5 className="resultSearchDescription mt-3">
                                    {intl.formatMessage({ id: 'resultsLabel' })}
                                    {searchedInputText || searchValue ? (
                                        <>
                                            {' '}
                                            {intl.formatMessage({ id: 'resultsLabel3' })}{' '}
                                            <b className="text-muted highlightedSearchTerm">
                                                {searchedInputText || searchValue}
                                            </b>
                                        </>
                                    ) : null}
                                    {/* Testo Helper "in : " */}
                                    {strutturaValue ? (
                                        <>
                                            {' '}
                                            in <b>{strutturaCercataTitle}</b>{' '}
                                            <sup>
                                                <a
                                                    title={intl.formatMessage({ id: 'removeAfferenza' })}
                                                    className="resultSearchRemoveAfferenza"
                                                    onClick={() => this.removeStruttValueGET()}
                                                >
                                                    [x]
                                                </a>
                                            </sup>
                                        </>
                                    ) : null}
                                </h5>
                                {/* Testo Helper "X risultati" */}
                                {totalResults != undefined && (
                                    <>
                                        <hr />
                                        <h5>
                                            <b>{totalResults}</b>{' '}
                                            {intl.formatMessage({ id: 'resultsLabel2' })}
                                        </h5>
                                    </>
                                )}
                                {/* Pulsante per filtrare in base a struttura */}
                                {!search_loading && r_items.length > 0 && (
                                    <>
                                        <hr />
                                        <Filter
                                            items={searchQuerystringResults}
                                            search_query={searchedInputText || searchValue}
                                            checked={strutturaValue != null}
                                        />
                                    </>
                                )}
                                {/* Risultati */}
                                {!search_loading ? (
                                    r_items.length > 0 ? (
                                        <div className="mt-4" aria-live="polite">
                                            <div className="block listing">
                                                <PersonaTemplate
                                                    items={r_items}
                                                    full_width={true}
                                                    page={1}
                                                />
                                                {pages.map((pageItems, index) => (
                                                    <PersonaTemplate
                                                        key={`page-${index + 2}`}
                                                        items={pageItems}
                                                        full_width={true}
                                                        page={index + 2}
                                                    />
                                                ))}
                                                {isLoadingMore && (
                                                    <div className="d-flex justify-content-center mt-3">
                                                        <Spinner active />
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    ) : null
                                ) : (
                                    <div className="d-flex justify-content-center mt-3">
                                        <Spinner active />
                                    </div>
                                )}
                            </>
                        )}
                    {/* Messaggio fine Risultati */}
                    {fineRisultati && (
                        <div className="mt-4" aria-live="polite">
                            <h5 className="text-center">
                                {intl.formatMessage({ id: 'rubrica_endResult' })}
                            </h5>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

Body.propTypes = {
    data: PropTypes.object.isRequired,
    id: PropTypes.string.isRequired,
    content: PropTypes.object,
    dispatch: PropTypes.func.isRequired,
    intl: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,

    search_querystringResults: PropTypes.object,
    ssp_subrequests: PropTypes.object,

    search_items: PropTypes.array,
    search_loading: PropTypes.bool,

    dd_items: PropTypes.array,
    dd_loading: PropTypes.bool,

    subsite: PropTypes.object,
};

const mapStateToProps = (state, ownProps) => ({
    // SUBREQUEST
    ssp_subrequests: state.searchSchedaPersonaReducer?.subrequests,

    // RICERCA RISULTATI
    search_querystringResults:
        state.searchSchedaPersonaReducer?.subrequests?.['_rubrica_search'],
    search_items:
        state.searchSchedaPersonaReducer?.subrequests?.['_rubrica_search']?.items ||
        [],
    search_loading:
        state.searchSchedaPersonaReducer?.subrequests?.['_rubrica_search']
            ?.loading || false,

    // RICERCA DROPDOWN
    dd_querystringResults:
        state.searchSchedaPersonaReducer?.subrequests?.['_rubrica_search_dd'],
    dd_items:
        state.searchSchedaPersonaReducer?.subrequests?.['_rubrica_search_dd']
            ?.items || [],
    dd_loading:
        state.searchSchedaPersonaReducer?.subrequests?.['_rubrica_search_dd']
            ?.loading || false,

    subsite: state.subsite?.data,
});

export default connect(mapStateToProps)(injectIntl(withRouter(Body)));
